module.exports = __webpack_public_path__ + "img/file_detail.95358815.png";